<template>
  <div v-if="!loaded"></div>
  <div v-else>
    <div class="main-container">
      <div class="bread" v-if="!!$route.query.recommend">
        <template v-if="$route.query.recommend != 3">
          <router-link :to="{ name: 'Index' }">首页</router-link>
          <span class="slash">/</span>
        </template>
        <router-link
          v-if="$route.query.recommend != 3"
          :to="{
            name: 'IndexRecommendCourse',
            query: {
              title: $route.query.title,
              recommend: $route.query.recommend,
            },
          }"
        >
          {{ $route.query.title }}
        </router-link>
        <router-link
          v-else
          :to="{
            name: 'OpenCourse',
            query: {
              title: $route.query.title,
              nav: 5,
            },
          }"
        >
          {{ $route.query.title }}
        </router-link>
        <span class="slash">/</span>
        <span class="current">{{ course.package_name }}</span>
      </div>
      <div class="bread" v-else>
        <router-link :to="{ path: nav.url }">{{ nav.name }}</router-link>
        <span class="slash">/</span>
        <span class="current">{{ course.package_name }}</span>
      </div>

      <div class="cover-wrap">
        <div class="cover">
          <ImageClip :src="course.cover_img" :width="420" :height="279" :radius="5"></ImageClip>
        </div>
        <div class="right">
          <div class="title-wrap">
            <img class="icon" src="@/assets/images/course/package_course_icon.png" />
            <span class="title">{{ course.package_name }}</span>
          </div>
          <div class="period">
            <span> 包含{{ course.course_total }}门课程 | 共{{ course.section_total }}课节 </span>
          </div>
          <CourseShowPrice :course="course"></CourseShowPrice>
          <div>
            <a v-if="course.is_sold_out" class="btn btn-disabled">已售罄</a>
            <a v-else-if="course.has_buy" class="btn btn-disabled">
              已报名课程，请联系老师购买其他课程哦
            </a>
            <a v-else @click="buy" class="btn">立即购买</a>
          </div>
        </div>
      </div>
      <div class="package-detail-tabs">
        <BlockTabs style="width: 100%" :items="[{ id: 1, name: '包含课程' }]" isNew></BlockTabs>
        <div class="package-detail-free">已报名课程无需重复付费</div>
        <div class="package-detail-courses">
          <PackageCourse
            v-for="course in course.package_course_items"
            :key="course.id"
            :course="course"
            :notJumpCourse="true"
            :hideCoursePrice="true"
          ></PackageCourse>
        </div>
      </div>
      <div class="course-tabs-wrap">
        <BlockTabs
          class="course-tabs"
          :items="packageTabs"
          currentClass="bold5"
          isNew
          @changeTab="changePackageTab"
        ></BlockTabs>
        <template v-if="currentPackageTab == 1">
          <Rich
            v-if="!!course.detail"
            id="course-detail"
            class="tab-content-detail"
            v-html="course.detail"
            oncontextmenu="return false"
            onselectstart="return false"
          ></Rich>
          <Empty class="empty" v-else title="暂无课程介绍信息！" />
        </template>
        <div id="course-chapter" class="tab-content-plan" v-show="currentPackageTab == 2">
          <BlockTabs
            class="course-tabs son-course-tabs"
            :items="sonCourseTabs"
            currentClass="bold5"
            isNew
            @changeTab="changeSonCourseTab"
          ></BlockTabs>
          <CourseChapter :course="currentSonCourse" class="course-chapter"></CourseChapter>
        </div>
      </div>
    </div>
    <!-- 微信扫码 -->
    <el-dialog title="微信扫码报名" :visible.sync="showSignWxModal" width="400px">
      <vue-qr :text="signWxUrl" :size="200" class="center"></vue-qr>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showSignWxModal = false"> 确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VueQr from 'vue-qr';
import CourseShowPrice from '../../components/rich/CourseShowPrice.vue';
import PackageCourse from '../package/components/PackageCourse.vue';
import CourseChapter from '../../components/CourseChapter.vue';

export default {
  name: 'PackageCourseDetail',
  components: {
    VueQr,
    CourseShowPrice,
    PackageCourse,
    CourseChapter,
  },
  data() {
    return {
      id: this.$route.params.id,
      teaching_assistant_id: this.$route.query.teaching_assistant_id,
      loaded: false,
      showSignWxModal: false,
      course: {},
      packageTabs: [
        { id: 1, name: '课程详情' },
        { id: 2, name: '课程大纲' },
      ],
      currentPackageTab: '1',
      currentSonCourseTab: '0',
    };
  },
  computed: {
    signWxUrl() {
      const urlQuery = {
        ...this.$route.query,
        id: this.id,
      };

      // 使用for循环代替Object.entries，兼容性更好
      let queryParts = [];
      for (let key in urlQuery) {
        if (
          Object.prototype.hasOwnProperty.call(urlQuery, key) &&
          urlQuery[key] !== undefined &&
          urlQuery[key] !== null
        ) {
          queryParts.push(key + '=' + urlQuery[key]);
        }
      }
      const queryString = queryParts.join('&');
      // let showParams = `id=${this.id}&teaching_assistant_id=${this.teaching_assistant_id}`;
      return `${this.$store.state.commonSetting.h5_address}/packageCourseDetail?${queryString}`;
    },
    navigates() {
      return this.$store.state.navigates;
    },
    nav() {
      let nav = this.navigates.filter((n) => n.id == this.$route.query.nav)[0];
      if (nav && nav.url != '/index') {
        nav = { ...nav };
        let url = nav.url;
        if (url.indexOf('?') < 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += 'nav=' + nav.id;
        nav.url = url;
        return nav;
      }
      return { name: '选课中心', url: '/course' };
    },
    sonCourseTabs() {
      return this.course.package_course_items
        ? this.course.package_course_items.map((item) => ({
            id: item.id,
            name: item.course_title,
          }))
        : [];
    },
    currentSonCourse() {
      if (this.currentSonCourseTab === '0') {
        return this.course.package_course_items ? this.course.package_course_items[0] : {};
      } else {
        return this.course.package_course_items
          ? this.course.package_course_items.find((item) => item.id === this.currentSonCourseTab)
          : {};
      }
    },
  },
  created() {
    this.getCourse();
  },
  methods: {
    async getCourse() {
      this.loaded = true;
      let data = await this.$http.get(
        `/api/app/packageCourse/${this.id}`,
        {},
        {
          onError: (data) => {
            if (data.msg == '课程不存在!') {
              this.$error(data.msg);
              this.$router.push({ name: 'Course' });
            }
          },
        },
      );
      this.course = data;
      this.$webSeeSendTrack({
        event_id: 'package-course-show',
        event_type: 'click',
        data: {
          ...this.$route.query,
        },
      });
    },
    async buy() {
      this.showSignWxModal = true;
    },
    changePackageTab(item) {
      this.currentPackageTab = item.id;
    },
    changeSonCourseTab(item) {
      this.currentSonCourseTab = item.id;
    },
  },
};
</script>
<style lang="scss">
@import '@/modules/stu/css/package-detail.scss';
.package-course {
  margin-bottom: 20px;
}
.cover-wrap {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  background-size: 1240px 369px;
  background-position: -20px -5px;
  padding: 24px 33px 0 30px;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  .cover {
    margin: 0 36px 31px 0;
    flex-shrink: 0;
  }
  .right {
    position: relative;
    flex-grow: 1;
    margin-bottom: 31px;
    display: flex;
    // flex-flow: row wrap;
    // justify-content: space-between;
    flex-direction: column;
    .title-wrap {
      margin-bottom: 34px;
      display: flex;
      align-items: center;
      .icon {
        width: 45px;
        height: 15px;
        margin-right: 10px;
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        color: rgba(32, 36, 42, 1);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .period {
      font-size: 14px;
      color: #999999;
      line-height: 1;
      display: flex;
      margin-bottom: 34px;

      .ver-line {
        width: 1px;
        margin: 0 9px;
        background: #d9d9d9;
        display: inline-block;
      }
    }
    .btn {
      margin-top: 35px;
      padding: 12px 40px;
      background: $primary-color;
      border-radius: 20px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
      &:hover {
        background: linear-gradient(90deg, $primary-color-8, $primary-color);
      }
    }
    .btn-disabled {
      background: #bfbfbf;
      color: white;
      cursor: not-allowed;

      &:hover {
        background: #bfbfbf;
      }
    }
  }
}

.spell-qr {
  img {
    max-width: 100%;
    border-radius: 0 0 7px 7px;
    vertical-align: bottom;
  }
}
.course-tabs-wrap {
  background: white;
  border-radius: 5px;
  padding-top: 12px;

  ::v-deep {
    .tabs,
    .tab-item {
      border-radius: 5px;
    }
    .tab-item {
      margin-right: 0 !important;
      width: 124px !important;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
  }
  .course-tabs {
    .tab-item {
      padding-left: 25px;
      width: unset !important;
    }
  }

  .son-course-tabs {
    white-space: nowrap;
    overflow: auto;
    .tab-item {
      float: none;
      display: inline-block;
    }
  }

  .empty {
    border-radius: 15px;
  }

  .tab-content-detail {
    padding: 32px;
  }
  .course-chapter {
    .period-header {
      pointer-events: none;
    }
  }
}
</style>
